import {
  OutputAvailability,
  OutputContractKind,
  StepOutputContract,
} from '@/types/automationFields.ts';
import { makeDynamicOptionValue } from '@/pages/Editor/components/SharedFields/DataInputSelector/hooks/useDataInputOptions.ts';

export const getContractColor = (kind: OutputContractKind) => {
  if (kind === OutputContractKind.Incompatible) {
    return 'red';
  }
  if (kind === OutputContractKind.Explicit) {
    return 'blue';
  }
  if (kind === OutputContractKind.Derived) {
    return 'teal';
  }
  return 'gray';
};

export const getContractKindLabel = (kind: OutputContractKind) => {
  switch (kind) {
    case OutputContractKind.Explicit:
      return 'Explicit';
    case OutputContractKind.BuiltIn:
      return 'Built-in';
    case OutputContractKind.Derived:
      return 'Derived';
    case OutputContractKind.Incompatible:
      return 'Incompatible';
    case OutputContractKind.None:
      return 'None';
    default:
      return kind;
  }
};

export const getAvailabilityLabel = (availability?: OutputAvailability) => {
  return availability === OutputAvailability.RuntimeOptional ? 'May be unavailable' : 'Guaranteed';
};

export const getSourceLabel = ({ data_output }: StepOutputContract) => {
  return data_output.output_name
    ? `${data_output.step_name}: ${data_output.output_name}`
    : data_output.step_name;
};

export const getSchemaLabel = ({ contract }: StepOutputContract) => {
  if (contract.schema_label) {
    return contract.schema_label;
  }
  if (contract.schema_id && contract.version !== null) {
    return `${contract.schema_id} v${contract.version}`;
  }
  return getContractKindLabel(contract.kind);
};

export const buildOutputContractByOptionValue = (outputContracts: StepOutputContract[]) => {
  return new Map(
    outputContracts.map((outputContract) => [
      makeDynamicOptionValue(
        outputContract.data_output.step_id,
        outputContract.data_output.output_id,
      ),
      outputContract,
    ]),
  );
};
